import gql from 'graphql-tag';

export const ALERTS_QUERY = gql`
  query AlertsQuery {
    alert {
      id
      alertType
      publisherId
      publisherName
      accountManagerEmail
      currentState
      acknowledgedById
      notes
    }
  }
`;
